import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const AirTicketingDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                        <Link to="/TravelInsurance"> Travel Insurance</Link>
                     </li>
                     <li>
                      <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                     </li>
                     <li>
                      <Link to="/MICE"> MICE</Link>
                      </li>
                    <li>
                   <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                   </li>
                   <li>
                     <Link to="/HotelBooking"> Hotel Booking </Link>
                    </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
                {/**---<div className="widget widget_download">
                  <h5 className="widget-title">
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <Link to="#">
                        {' '}
                        Company Profile <FaAngleDoubleRight />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        {' '}
                        Zip File Download <FaAngleDoubleRight />
                      </Link>
                    </li>
                  </ul>
                </div>--- */}
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner1.jpg" alt="img" />
                  </div>
                  <div className="details">
                    <h4>
                    Best Deals on Domestic & International Flights
                    </h4>
                    <p>
                    Bhavanya Travel Mart Pvt Ltd offers competitive air ticketing services for
                    both domestic and international destinations. Our experienced travel consultants 
                    find you the best flight options with the lowest fares, saving you time and money. 
                    We handle last-minute bookings, group fares, and special requests efficiently.
                    </p>
                    
                    {/**---<h4>Why Choose Us?</h4>
                    <p>
                      It is a long established fact that a reader will be distr
                      acted bioiiy the end gail readable content of a page when
                      looking.
                    </p>
                    <div
                      className="accordion accordion-inner accordion-icon-left mt-3 mb-4"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            What services do you offer?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Many desktop publishing packages and web page
                            editors now use Lorem Ipsum as their default model
                            text, search for 'lorem ipsum' will uncover
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How long does it take for you to complete a project?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Many desktop publishing packages and web page
                            editors now use Lorem Ipsum as their default model
                            text, search for 'lorem ipsum' will uncover
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            How much does it cost to work with your agency?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Many desktop publishing packages and web page
                            editors now use Lorem Ipsum as their default model
                            text, search for 'lorem ipsum' will uncover
                          </div>
                        </div>
                      </div>
                    </div>--- */}
                    <h4>Why Choose Us ?</h4>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> 24/7 Booking Support
                          </li>
                          <li>
                            <FaCheckCircle /> Lowest Fare Guarantee
                            companies
                          </li>
                          <li>
                            <FaCheckCircle /> Instant Confirmation
                          </li>
                          <li>
                            <FaCheckCircle /> Group & Corporate Bookings Available
                          </li>
                        </ul>
                      </div>

                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Book your flight today and fly with ease!
                    </Link>
                  </div>
                      {/***----<div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Creating a Balanced and Nutritious
                          </li>
                          <li>
                            <FaCheckCircle /> iTechnology that helps grow
                            companies
                          </li>
                          <li>
                            <FaCheckCircle /> Everything you need to succeed
                          </li>
                        </ul>
                      </div>--- */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default AirTicketingDetails;
